<template>
<div v-if="isShow" id="main-detail">
<header v-if="timelineDetail">
    {{ timelineDetail.displayname }}
    <div class="h-left">
        <a @click="$emit('close', timelineDetail)"><img src="~@/assets/images/icon02.svg" /></a>
    </div>
    <!-- <div class="h-right" v-if="parseInt(timelineDetail.user_id) !== parseInt(userDetail.id)">
        <a><img src="~@/assets/images/icon06.svg" /></a>
    </div> -->
</header>
<div id="wrap" v-if="timelineDetail">
    <div id="fbt" v-if="parseInt(timelineDetail.user_id) !== parseInt(userDetail.id)">
        <div class="fbt">
            <a @click="likeUser(timelineDetail.user_id, timelineDetail.is_like)" v-if="parseInt(timelineDetail.is_like) !== IS_LIKE && parseInt(timelineDetail.look_at_me_status) !== IS_LOOK_AT_ME">
                <div class="fbt05">
                    <span class="white"><i class="fas fa-heart"></i> いいね</span>
                </div>
            </a>
            <a @click="lookAtMe(timelineDetail.user_id)" v-if="parseInt(timelineDetail.is_like) === IS_LIKE && parseInt(timelineDetail.look_at_me_status) !== IS_LOOK_AT_ME">
                <div class="fbt05">
                    <span class="white">みてね！済み</span>
                </div>
            </a>
            <a v-if="parseInt(timelineDetail.look_at_me_status) === IS_LOOK_AT_ME || parseInt(timelineDetail.first_message_status) === FIRST_MESSAGE_STATUS_APPROVING">
                <div class="fbt05" style="background: #bdbdbd">
                    <span class="white">みてね！済み</span>
                </div>
            </a>
            <a v-if="parseInt(timelineDetail.look_at_me_status) !== IS_LOOK_AT_ME && parseInt(timelineDetail.first_message_status) !== FIRST_MESSAGE_STATUS_APPROVING" @click="opendSendMessageLike(parseInt(timelineDetail.look_at_me_status), parseInt(timelineDetail.first_message_status))">
                <div class="fbt06">
                    <span class="white"><i class="fas fa-comment-dots"></i> メッセージ＆いいね</span>
                </div>
            </a>
            <a v-if="parseInt(timelineDetail.look_at_me_status) === IS_LOOK_AT_ME || parseInt(timelineDetail.first_message_status) === FIRST_MESSAGE_STATUS_APPROVING">
                <div class="fbt06" style="background: #bdbdbd">
                    <span class="white">メッセージ＆いいね</span>
                </div>
            </a>
        </div>
    </div>
    <div id="fbt" v-else>
        <div class="fbt">
            <a @click="redirectEdit">
                <div class="fbt05" style="background: #bdbdbd">
                    <span class="white">編集</span>
                </div>
            </a>
            <a @click="deleted">
                <div class="fbt06 btn_del_red">
                    <span class="white">削除</span>
                </div>
            </a>
        </div>
    </div>

    <div class="prof-ph">
        <p v-if="parseInt(timelineDetail.user_id) !== parseInt(userDetail.id)" class="fav"><i :class="timelineDetail.is_like === IS_LIKE || this.likeStatus ? 'fas fa-heart red' : 'fas fa-heart'"></i></p>
        <a v-if="parseInt(timelineDetail.user_id) !== parseInt(userDetail.id)" @click="redirectUserDetail()">
            <div class="fbt07">
                <span class="white"><i class="fas fa-address-card"></i> プロフィール</span>
            </div>
        </a>
        <p class="prof-ph03">{{ timelineDetail.displayname }}</p>
        <p class="prof-ph04">
            <span style="white-space: pre;">{{ getLiving(timelineDetail.living_area) + " " }} {{timelineDetail.age}}歳 {{" " + getGender(timelineDetail.sex) }}</span>
            <i class="fas fa-heart red" style="margin-left: 7px;"></i> {{parseInt(timelineDetail.total_like)}}いいね！
            <span v-if="parseInt(timelineDetail.sex) === FEMALE">
                <i class="fas fa-phone pink" v-if="parseInt(timelineDetail.enabled_call) === IS_CALL"></i> 通話OK&nbsp;
                <i class="fas fa-calendar-check pink2" style="margin-left: 7px;" v-if="parseInt(timelineDetail.waiting_for_meet) === IS_WAITING_FOR_MEET"></i>本日OK
            </span>
        </p>
        <div class="prof-bg"></div>
        <img :src="getImageUrl(timelineDetail.avatar_url)" />
    </div>

    <div class="clearfix">
        <p class="real-day01">{{ formatDateTime2(timelineDetail.free_at) }} 募集</p>
        <p class="real-day02">3分前</p>
    </div>
    <div class="txt-area">
        <p style="word-break: break-word;">
            {{ timelineDetail.content }}
        </p>
    </div>
</div>
<div id="wrap" v-else>
    <div class="prof-ph">
        <p class="fav"><i class="fas fa-heart"></i></p>
        <a>
            <div class="fbt07">
                <span class="white"><i class="fas fa-address-card"></i> プロフィール</span>
            </div>
        </a>
        <p class="prof-ph03">
            <Skeletor width="50" />
        </p>
        <p class="prof-ph04">
            <Skeletor width="50" />
            <i class="fas fa-heart red"></i>
            <Skeletor width="40" />
            <i class="fas fa-phone pink"></i>
            <Skeletor width="30" />
            <i class="fas fa-calendar-check pink2"></i>
            <Skeletor width="20" />
        </p>
        <div class="prof-bg"></div>
        <img src="images/female01.jpg" />
    </div>

    <div class="clearfix">
        <p class="real-day01">
            <Skeletor width="50" />
        </p>
        <p class="real-day02">
            <Skeletor width="20" />
        </p>
    </div>
    <div class="txt-area">
        <p>
            <Skeletor height="30" />
        </p>
    </div>
</div>
<basic-dialog :active="isSendMessageLike">
    <div class="content-send-like-message">
        <p>メッセージを送りましょう！</p>
        <textarea @keypress="updateNumberMessage" v-model="contentMessageLike" placeholder="お相手の共通点や気になったことを伝えてみましょう！※メッセージ付いいね！ではポイントが消費されます。※メールアドレスLINE ID・カカオID Facebookのアカウントやその他SNSのID、電話番号などあなたできる個人情報は送信できません。"></textarea>
        <p class="error">{{ validMessage }}</p>
        <p class="note">あと{{ numberStringMessage }}文字</p>
        <div class="iine-btn1 submit" @click="submitSendMessageLike">
            <i class="fas fa-comment-dots"></i>メッセージ＆いいねする
        </div>
        <div class="iine-btn2 cancel" @click="closeSendMessageLike">
            キャンセル
        </div>
    </div>
</basic-dialog>
</div>
<detail v-if="isShowDetailUser" :idUser="timelineDetail.user_id" @close="closeDetailUser"></detail>
<create v-if="isShowEdit" :timelineDetail="timelineDetail" @closeEdit="closeEdit"></create>
<!-- Subscription -->
<subscriptionAlert :active="isShowAlertSubscription">
    <div class="subscription">
        <div class="title">有料会員の登録が必要です</div>
        <div class="content">簡単ステップで<br>有料会員の登録を済ませましょう</div>
        <div class="btn1" @click="openSubscription()">詳しく見る</div>
    </div>
</subscriptionAlert>
<!-- Verify age -->
<subscriptionAlert :active="isShowAlertVerifyAge">
    <div class="subscription">
        <div class="title">年齢認証が必要です</div>
        <div class="content">
            <h3>簡単ステップで<br>年齢確認を済ませましょう。</h3>
            <br>
            お相手とのメッセージを行うためには<br>法令により年齢確認が必要となります。
        </div>
        <div class="btn1" @click="openVerifyAge()">詳しく見る</div>
    </div>
</subscriptionAlert>
<div id="subscription" class="hidden-right">
    <subscription :isShow="true" @close="closeSubscription"></subscription>
</div>
<div id="very-age" class="hidden-right">
    <veryAge :isShow="true" @close="closeVerifyAge"></veryAge>
</div>
<successDialog :active="isShowAlertProcessApprove" @close="isShowAlertProcessApprove = false">
    <template v-slot:message>
        <h3>現在年齢認証中です。</h3>
        <p>最大24時間かかります。</p>
    </template>
</successDialog>
</template>

<script>
import {
    mapGetters, mapActions
} from "vuex";
import mixin from "@/mixin";
import {
    Skeletor
} from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";
import CONSTANTS from "@/constants";
import BasicDialog from "../user/components/basicDialog.vue";
import detail from "../user/detail.vue"
import create from "./create"
import subscriptionAlert from "@/views/user/components/subscriptionAlert"
import subscription from '../profile/subscription'
import veryAge from '../profile/veryAge.vue'
import successDialog from '@/views/components/successDialog'
export default {
    components: {
        Skeletor, BasicDialog, detail, create,
        subscriptionAlert,
        subscription,
        veryAge,
        successDialog,
    },
    props: {
        isShow: Boolean,
        timelineDetail: Object
    },
    emits: ['close'],
    mixins: [mixin],
    data: () => ({
        likeStatus: false,
        IS_LIKE: CONSTANTS.IS_LIKE,
        IS_CALL: CONSTANTS.IS_CALL,
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        FEMALE: CONSTANTS.FEMALE,
        IS_LOOK_AT_ME: CONSTANTS.IS_LOOK_AT_ME,
        isSendMessageLike: false,
        contentMessageLike: null,
        validMessage: null,
        isValid: false,
        numberStringMessage: 200,
        FIRST_MESSAGE_STATUS_APPROVING: CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING,
        isShowDetailUser: false,
        scrollHeight: null,
        isShowEdit: false,
        isShowAlertSubscription: false,
        isShowAlertVerifyAge: false,
        isShowAlertProcessApprove: false
    }),
    computed: {
        ...mapGetters(["metadata", "defaultToken", "userDetail"]),
    },
    mounted() {
        document.addEventListener("click", (evt) => {
            const flyoutElement = document.getElementsByClassName("subscription")[0];
            let targetElement = evt.target
            do {
                if (targetElement == flyoutElement) {
                    // console.log(flyoutElement)
                    return;
                }
                targetElement = targetElement.parentNode;
            } while (targetElement);
            const wrap = document.querySelector(".wrap");
            if (wrap == evt.target) {
                this.isShowAlertSubscription = false
                this.isShowAlertVerifyAge = false
            }
        });
    },
    methods: {
        ...mapActions({
            setFooter: 'layout/setFooter'
        }),
        closeSubscription() {
            this.setFooter(false)
            document.getElementById('subscription').classList.remove('show-right')
            document.getElementById('subscription').classList.add('hidden-right')
        },
        openSubscription() {
            this.isShowAlertSubscription = false
            document.getElementById('subscription').classList.add('show-right')
            document.getElementById('subscription').classList.remove('hidden-right')
        },
        openVerifyAge() {
            this.isShowAlertVerifyAge = false
            document.getElementById('very-age').classList.add('show-right')
            document.getElementById('very-age').classList.remove('hidden-right')
        },
        closeVerifyAge(val) {
            if (val) {
                this.userDetail.is_verify_age = CONSTANTS.PC_VERY_AGE
            }
            this.setFooter(false)
            document.getElementById('very-age').classList.remove('show-right')
            document.getElementById('very-age').classList.add('hidden-right')
        },
        redirectEdit() {
            document.getElementById('main-detail').style.display = "none"
            this.isShowEdit = true
        },
        closeEdit(val) {
            document.getElementById('main-detail').style.display = "unset"
            this.isShowEdit = false
            if (val) {
                this.timelineDetail.content = val
            }
        },
       
        deleted() {
            let formData = new FormData()
            formData.append('keijiban_id', this.timelineDetail.id)
            formData.append('token', this.defaultToken)
            this.$store.dispatch('timeline/deleteTimeline', formData)
            
            this.$emit('close', true)
        },
        redirectUserDetail() {
            document.getElementById('main-detail').style.display = "none"
            // this.setFooter(false)
            this.isShowDetailUser = true
        },
        closeDetailUser() {
            document.getElementById('main-detail').style.display = "unset"
            // this.setFooter(false)
            this.isShowDetailUser = false
            setTimeout(() => {
                 window.scrollTo(0, this.scrollHeight);
            }, 1)
        },
        lookAtMe(id) {
            let formData = new FormData()
            formData.append('token', this.defaultToken)
            formData.append('user_look_at_id', id)
            formData.append('message', CONSTANTS.MESSAGE_LOOK_AT_ME)
            this.$store.dispatch('like/lookAtMe', formData).then((data) => {
                this.timelineDetail.look_at_me_status = CONSTANTS.IS_LOOK_AT_ME
            }).catch(err => {
                console.log(err)
            })
        },
        likeUser(id, isLike) {
            if (isLike !== CONSTANTS.IS_LIKE) {
                let formData = new FormData();
                formData.append("type", 0);
                // formData.append("token", this.token);
                formData.append("user_like_id", id);
                this.$store
                    .dispatch("user/likeUser", formData)
                    .then(() => {
                        this.likeStatus = true
                        this.timelineDetail.is_like = CONSTANTS.IS_LIKE;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        opendSendMessageLike(lookAt, first_message_status) {
            if (lookAt !== CONSTANTS.IS_LOOK_AT_ME && first_message_status !== CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING) {
                
                if (parseInt(this.userDetail.is_subscription) !== CONSTANTS.IS_SUBSCRIPTION && parseInt(this.userDetail.sex) === CONSTANTS.MALE) {
                    this.isShowAlertSubscription = true
                    return
                }
                if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.NO_VERY_AGE) {
                    this.isShowAlertVerifyAge = true
                    return
                }
                if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.PC_VERY_AGE) {
                    this.isShowAlertProcessApprove = true
                    return
                }
                this.isSendMessageLike = true
            }
        },
        submitSendMessageLike() {
            if (this.contentMessageLike.length < 10) {
                this.isValid = true
                this.validMessage = "10文字以上を入カしてください"
            } else {
                let formData = new FormData()
                formData.append("token", this.defaultToken)
                formData.append("type", 0)
                formData.append("user_like_id", this.timelineDetail.user_id)
                formData.append("message", this.contentMessageLike)
                this.$store
                    .dispatch("profile/sendLikeMessage", formData)
                    .then((data) => {
                        this.pageCurrent = 1
                        this.timelineDetail.first_message_status = CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING
                        this.closeSendMessageLike()
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        updateNumberMessage() {
            this.numberStringMessage--;
            if (this.numberStringMessage === 0) {
                document.querySelector("textarea").setAttribute("disabled", true);
            }
        },
        closeSendMessageLike() {
            this.isSendMessageLike = false;
            this.numberStringMessage = 200;
            document.querySelector("textarea").setAttribute("disabled", false);
            this.isValid = false;
            this.validMessage = null;
            this.contentMessageLike = null;
        },
        getLiving(id) {
            if (!this.metadata.user_profile_list) return;
            let living = this.metadata.user_profile_list.living_area.filter(
                (item) => {
                    return item.value === id;
                }
            );
            if (living[0]) {
                return living[0].name;
            }
            return null;
        },
    }
};
</script>


<style scoped>
  .iine-btn2 {
    font-size: 12px;
}

.content-send-like-message {
    background: #ffff;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.content-send-like-message textarea {
    width: 99%;
    height: 150px;
    margin-top: 15px;
}

.content-send-like-message div {
    margin: 5px;
    padding: 2px;
    color: #fff;
}

.content-send-like-message div.cancel {
    width: 50%;
}

.content-send-like-message div.submit {
    width: 80%;
}

.content-send-like-message p {
    margin: 5px;
}

.content-send-like-message .error {
    height: 10px;
    color: red;
    font-size: 10px;
    text-align: left;
    width: 100%;
}

.content-send-like-message p.note {
    width: 100%;
    text-align: right;
    background: none;
    padding: 0px;
    font-size: 10px;
}
.btn_del_red {
    background: linear-gradient(to right, rgb(188 99 99) 0%, rgb(158 90 90) 100%);
}
.subscription {
    background: #fff;
    padding-bottom: 10px;
}
.subscription .content {
    padding: 20px;
}
.subscription .btn1 {
    color: #fff;
    padding: 10px;
}
.hidden-right {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    overflow: hidden;
}
.show-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
    z-index: 999999;
    background: #fff;
    overflow: scroll;
    height: 100vh;
}
#subscription, #very-age {
    transition: all 0.2s;
}
</style>